/*
 * @Author: Ygm
 * @Date: 2023-08-03 10:56:32
 * @LastEditors: Ygm
 * @LastEditTime: 2023-08-03 10:56:32
 * @Description: 公文相关枚举
 */
// 发送方式
const sendMethodEnum = {
  1: '网络发送',
  2: '短信发送'
}

// 下载方式
const downloadMethodEnum = {
  0: '直接下载',
  1: '密码下载'
}

// 项目计划状态
const planStatusEnum = {
  0: '【结束】',
  1: '【进行】'
}

// 流程状态
const processStatusEnum = {
  4: '流程中',
  5: '流程结束'
}

// 标签状态
const tagStatusEnum = {
  0: '待审批',
  1: '审批通过',
  2: '审批不通过'
}

// 标签颜色
const tagColorEnum = {
  0: 'orange',
  1: '#23bf71',
  2: '#ff5959',
  3: '#999'
}

// 标签背景色
const tagBgColor = {
  0: '#ffead6',
  1: '#d9faea',
  2: '#ffdede',
  3: '#999'
}

// 流转意见颜色
const opinionColorEnum = {
  0: '#4d7cfe',
  1: '#23bf71',
  2: 'red',
  3: '#bbb',
  4: 'blue',
  5: ''
}

// 流转意见状态
const opinionStatusEnum = {
  0: '发文',
  1: '通过',
  2: '退回',
  3: '撤回',
  4: '流程中',
  5: '已结束'
}

// 流转意见图标
const opinionIconEnum = {
  null: 'pass',
  0: 'pass',
  1: 'pass',
  2: 'no_pass',
  3: 'no_pass',
  4: 'pass',
  5: 'pass'
}

// 操作类型
const operationTypeEnum = {
  add: '发文',
  edit: '编辑'
}

// 操作类型
const operationTypeEnum1 = {
  add: '发布',
  edit: '编辑'
}

// 编辑公文字段类型
const editDocTypeEnum = {
  PLAN: '进行的项目计划',
  WORKGROUP: '接收机构',
  OFFICIAL_SPACE: '公文分类',
  TZ_NEED_REPORT: '是否需要反馈',
  TASK_CYCLE_TYPE: '任务周期类型',
  TIME_RANGE: '任务时间范围',
  DATE_RANGE: '任务日期范围',
  CYCLE_FREQUENCY: '周期频次',
  FORM_CONTENT: '表单内容',
  IS_RATIFY: '审批人',
  RECIPIENT_TYPE: '接收者类型',
  TZ_SMS_CONTENT: '短信内容'
}

export {
  sendMethodEnum,
  downloadMethodEnum,
  planStatusEnum,
  processStatusEnum,
  tagStatusEnum,
  tagColorEnum,
  tagBgColor,
  opinionColorEnum,
  opinionStatusEnum,
  opinionIconEnum,
  operationTypeEnum,
  editDocTypeEnum,
  operationTypeEnum1
}



// WEBPACK FOOTER //
// ./src/view/pages/Enum/index.js